import { Avatar, Card, Typography } from "antd";
import { useEffect, useState } from "react";
import { useUser } from "../../api/Users";
import { useCareType } from "../../hooks/useUserDisplay";
import { getAvatarPath } from "../../utils/userUtil";
import "./UserDisplay.css";

const UserDisplay = ({ user = {}, size = 100, fullDetails = false, style }) => {
  const { FirstName, LastName, Email } = user;
  let name =
    FirstName && LastName
      ? `${FirstName} ${LastName}`
      : FirstName
      ? FirstName
      : Email;
  return (
    <div className="user-display" style={style}>
      <div className="avatar">
        <Avatar
          shape="square"
          size={size}
          src={getAvatarPath(user)}
          icon={name.substring(0, 1)}
          style={{ marginRight: "10px" }}
        />
      </div>
      <div className="text">
        {name}
        {fullDetails && (
          <>
            <br />
            <Typography.Text type="secondary">{Email}</Typography.Text>
          </>
        )}
      </div>
    </div>
  );
};

export const UserDisplayCard = ({ userId }) => {
  const [user, setUser] = useState();
  let { data } = useUser(userId);

  useEffect(() => {
    if (data?.User) setUser(data.User);
  }, [data]);
  return <Card>{user && <UserDisplay user={user} size={75} />}</Card>;
};

export const UserNameDisplay = ({ user, children }) => {
  const serviceType = useCareType(user?.CareType);
  return (
    <div style={{ textAlign: "center" }}>
      <Avatar
        src={getAvatarPath(user)}
        shape="square"
        size={75}
        icon={user?.FirstName?.substring(0, 1)}
      />
      <Typography.Title level={4} style={{ marginBottom: 0, color: "#9D79BC" }}>
        {user?.FirstName} {user?.LastName}
      </Typography.Title>
      {user?.CareType && (
        <Typography.Title type="secondary" level={5} style={{ marginTop: 0 }}>
          {serviceType}
        </Typography.Title>
      )}
      {children}
    </div>
  );
};

export default UserDisplay;
